
import React from 'react';
import { ChevronRight, Users } from 'lucide-react';
import { City } from '../../data/types/city-types';
import { useLanguage } from '../../contexts/language';

interface CityCardProps {
  city: City;
  onSelect: (cityId: string) => void;
  getCityColor: (presence: string) => string;
  getFundingPercentage: (city: City) => number;
}

const CityCard: React.FC<CityCardProps> = ({ 
  city, 
  onSelect, 
  getCityColor, 
  getFundingPercentage 
}) => {
  const { t } = useLanguage();
  
  // Make sure we get a valid funding percentage (defaulting to 0 if invalid)
  const fundingPercentage = (() => {
    const percentage = getFundingPercentage(city);
    return !isNaN(percentage) && percentage >= 0 ? Math.round(percentage) : 0;
  })();
  
  return (
    <div 
      className="p-4 bg-gray-50 rounded-lg border border-gray-200 hover:border-purple-300 cursor-pointer transition-colors"
      onClick={() => onSelect(city.city_id)}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <div 
            className="w-4 h-4 rounded-full mr-3" 
            style={{ backgroundColor: getCityColor(city.church_presence) }}
          />
          <h4 className="font-semibold text-gray-800">{city.name}</h4>
        </div>
        <ChevronRight className="h-5 w-5 text-purple-600" />
      </div>
      <div className="flex justify-between mt-3 text-sm">
        <div className="text-gray-700 flex items-center">
          <Users className="h-4 w-4 mr-1.5" />
          <span>{city.missionaries} {t('missionaries')}</span>
        </div>
        <div className="font-medium text-[#1EAEDB]">
          {fundingPercentage}% {t('funded')}
        </div>
      </div>
    </div>
  );
};

export default CityCard;
